<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Listado de Pedidos</h4>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <load-spinner v-if="loading"></load-spinner>
                  <order-list v-else-if="orders.length > 0" :orders="orders" />
                  <div v-else class="text-center">
                     <div class="mb-4">
                        <i class="bx bx-info-circle text-danger display-4"></i>
                     </div>
                     <h3>Sin Registros</h3>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from '@/layouts/Main'
   import OrderList from '@/components/widgets/orders/orderList'
   import LoadSpinner from '@/components/widgets/LoadSpinner'
   import axios from 'axios'

   export default {
      name: 'OrdersList',
      data () {
         return {
            loading: true,
            completeOrdersList: [ ]
         }
      },
      computed: {
         zoneSelected() {
            return this.$store.state.user.selectedZone
         },
         orders() {
            return this.completeOrdersList.filter(zone => zone.codrep == this.zoneSelected)
         }
      },
      components: {
         Layout, OrderList, LoadSpinner
      },
      async created() {
         let zonas = this.$store.state.user.zones
         let params = "json="+JSON.stringify({ zonas })
          
         await axios({url: 'https://portal.asein.es/api-v2/cargar-pedidos', data: params, method: 'POST' })
         .then(resp => {
            if (resp.data[0].registros > 0) {
               this.completeOrdersList = resp.data
            }
            this.loading = false
         })
         .catch(err => {
            console.log(err)
         })
      }
   }
</script>
